import { SVGProps } from "react";

export const CatalogIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    {...props}
  >
    <path
      d="M1.17129 9.88889H5.53964M20.8289 9.88889H9.90799M8.8159 13.2222H13.1843M17.5526 7.66667L14.2763 1M4.44755 7.66667L7.72381 1"
      stroke="var(--start-color, black)"
      strokeOpacity="0.9"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.7543 15.73C19.2224 18.2556 18.957 19.5178 18.0561 20.2589C17.1551 21 15.8861 21 13.3481 21H8.65209C6.11407 21 4.84507 21 3.94519 20.2589C3.04312 19.5178 2.77665 18.2556 2.2459 15.73L1.77739 13.5078C0.993274 9.78224 0.600122 7.9189 1.58409 6.68224C2.56697 5.44446 4.4399 5.44446 8.18467 5.44446H13.8155C17.5613 5.44446 19.4321 5.44446 20.4161 6.68224C21.1478 7.60446 21.1183 8.87335 20.7306 11"
      stroke="var(--start-color, black)"
      strokeOpacity="0.9"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
